import { useMemo } from 'react'

// Hook for StepTypeActivity: provides static list of assignment types
// with ids, titles and subtitles used for UI.
export const useStepTypeActivity = () => {
	const types = useMemo(
		() => [
			{
				id: 'career_quiz',
				emoji: '📝',
				title: 'Career Quiz & Personality Review',
				subtitle: 'Explore interests and strengths.',
			},
			{
				id: 'career_essay',
				emoji: '✍️',
				title: 'Career Reflection Essay',
				subtitle: 'Write a short career reflection.',
			},
			{
				id: 'country_exploration',
				emoji: '🔍',
				title: 'Country Exploration',
				subtitle: 'Explore study destinations.',
			},
			{
				id: 'university_exploration',
				emoji: '🔍',
				title: 'University Exploration',
				subtitle: 'Explore universities and programs.',
			},
			{
				id: 'pathway_alignment',
				emoji: '🔍',
				title: 'Masar Selection Alignment',
				subtitle: 'Align pathways and options.',
			},
			{
				id: 'profile_building',
				emoji: '📄',
				title: 'Profile Building',
				subtitle: 'Build key profile details.',
			},
			{
				id: 'bragsheet_builder',
				emoji: '📋',
				title: 'Complete Brag Sheet for LoR',
				subtitle: 'Generate a brag sheet for recommendations.',
			},
			{
				id: 'class_presentation',
				emoji: '🎤',
				title: 'Class Presentation',
				subtitle: 'Prepare and present work.',
			},
		],
		[],
	)

	return { types }
}

